import { useState, useEffect } from "react";
import { faXmarkCircle, faCheckCircle, faPaperPlane, faHistory } from "@fortawesome/free-solid-svg-icons";
import { ModalBodylHistorial } from "../historial-solicitudes/modalHistorial/modalHistorial";
import { formatFecha, cierraModal } from "../../utils/funciones";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSolicitudesCurso } from "./useSolicitudesCurso";
import { useLocation } from "react-router-dom";

export const ModalBody = ({ obj, visibleBtns }) => {
  const [visibleBotones, setVisibleBotones] = useState(false);
  const {
    aceptaSolicitud,
    rechazaSolicitud,
    returnAccesos,
    returnTipoContrato,
    visibleHistorial,
    setVisibleHistorial,
    idSolicitud,
    setIdSolicitud,
    traerDocumentos,
    documentos,
  } = useSolicitudesCurso();
  const location = useLocation();

  const validarBotones = (path) => {
    if (path === "/solicitudes-traspaso") {
      setVisibleBotones(visibleBtns);
    } else {
      const resp = returnAccesos(localStorage.getItem("id_perfil"), obj.id_tipo_solicitud, obj.id_estado_solicitud);
      setVisibleBotones(resp);
    }
  };

  useEffect(() => {
    traerDocumentos(obj);
    validarBotones(location.pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {visibleHistorial ? (
        <ModalBodylHistorial
          fnAtras={() => {
            setVisibleHistorial(false);
          }}
          id={idSolicitud}
        />
      ) : (
        <>
          {obj ? (
            <div className="pb-3 cuerpoModalData d-flex flex-column gap-1">
              <div>
                <h4>Datos del colaborador</h4>
                <div>
                  <table className="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th>Nro personal</th>
                        <th>Colaborador</th>
                        <th>RUT</th>
                        <th>Estatus contrato</th>
                      </tr>
                    </thead>
                    <tbody className="h6">
                      <tr>
                        <td>{obj.persona.id_sap || "No posee id SAP"}</td>
                        <td>
                          {obj.persona.nombre} {obj.persona.apellido_pat} {obj.persona.apellido_mat}
                        </td>
                        <td>{obj.persona.identificacion}</td>
                        <td>{returnTipoContrato(obj.persona.tipo_contrato)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {![2, 4, 5].includes(obj.id_tipo_solicitud) && (
                <div>
                  <h4>Datos asociados a SAP</h4>
                  <div>
                    <table className="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th>Instalación actual</th>
                          {[3].includes(obj.id_tipo_solicitud) && <th>Instalación a traspasar</th>}
                          {/* {![3].includes(obj.id_tipo_solicitud) && ( */}
                          <>
                            <th>Cargo actual</th>
                            <th>Cargo solicitado</th>
                            <th>PHTD actual</th>
                            <th>PHTD solicitado</th>
                          </>
                          {/* )} */}
                        </tr>
                      </thead>
                      <tbody className="h6">
                        <tr>
                          <td>{obj.instalacion_actual}</td>
                          {[3].includes(obj.id_tipo_solicitud) && <td>{obj.nombre_instalacion_destino}</td>}
                          {/* {![3].includes(obj.id_tipo_solicitud) && ( */}
                          <>
                            <td>{obj.nombre_cargo_actual.split("|")[1]}</td>
                            <td>{obj.nombre_nuevo_cargo ? obj.nombre_nuevo_cargo : "---"}</td>
                            <td>{obj.nombre_cargo_actual.split("|")[0]}</td>
                            <td>{obj.nuevo_plan_horario.split("|")[0] ? obj.nuevo_plan_horario.split("|")[0] : "---"}</td>
                          </>
                          {/* )} */}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {![3, 4, 5].includes(obj.id_tipo_solicitud) && (
                <div className="row">
                  <h4>Datos asociados a temporis</h4>
                  <div className="col col-12">
                    <table className="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th>Unidad solicitada</th>
                          <th>Cargo</th>
                          <th>Plan horario</th>
                        </tr>
                      </thead>
                      <tbody className="h6">
                        <tr>
                          <td>{obj.descripcion_unidad_temporis.split(" - ")[0]}</td>
                          <td>{obj.descripcion_unidad_temporis.split(" - ")[1]}</td>
                          <td>{obj.nuevo_plan_horario.split("|")[1]}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {[4].includes(obj.id_tipo_solicitud) && (
                <div className="row">
                  <h4>Datos complementarios</h4>
                  <div className="col col-8">
                    <table className="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th>Estatus contrato</th>
                          <th>Fecha limite renovación</th>
                        </tr>
                      </thead>
                      <tbody className="h6">
                        <tr>
                          <td>
                            {obj.tipo_cambio_contrato === 1 && "Cambiar a indefinido"}
                            {obj.tipo_cambio_contrato === 2 && "Renovar plazo fijo"}
                          </td>
                          <td>
                            {obj.tipo_cambio_contrato === 1 && "31-12-9999"}
                            {obj.tipo_cambio_contrato === 2 && formatFecha(obj.fecha_renovacion_contrato.replace(/-/g, ""))}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              <div className="col col-12">
                <div className="row">
                  {[5].includes(obj.id_tipo_solicitud) && (
                    <div>
                      <h4>Baja del colaborador</h4>

                      <div className="row">
                        <div className="col-5">
                          <table className="table table-bordered table-sm">
                            <thead>
                              <tr>
                                <th>Fecha solicitud de baja</th>
                              </tr>
                            </thead>
                            <tbody className="h6">
                              <tr>
                                <td>{formatFecha(obj.fecha_inicio_cambio.replace(/-/g, ""))}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div className="col-7">
                          <table className="table table-bordered table-sm">
                            <thead>
                              <tr>
                                <th>Causal invocada</th>
                              </tr>
                            </thead>
                            <tbody className="h6">
                              <tr>
                                <td>{obj.clausula_despido?.nombre || "No especifíca"}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="mt-3">
                        <table className="table table-bordered table-sm">
                          <thead>
                            <tr>
                              <th>Motivo desvinculación</th>
                            </tr>
                          </thead>
                          <tbody className="h6">
                            <tr>
                              <td>{obj.motivo_desvinculacion}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                  {![5].includes(obj.id_tipo_solicitud) && (
                    <div className="col col-5 mt-3">
                      <table className="table table-bordered table-sm">
                        <thead>
                          <tr>
                            <th>Fecha efectiva del cambio</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{formatFecha(obj.fecha_inicio_cambio.replace(/-/g, ""))}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>

              {/* ACA VA UNA CONDICION */}

              {/* {![3].includes(obj.id_tipo_solicitud) && ![1].includes(obj.id_estado_solicitud) && ( */}
                <div className="col col-12 mt-2">
                  <div className="row">
                    <h4>Documentos adjuntos</h4>

                    <div className="docs-container mt-2">
                      {documentos?.map((el, idx) => {
                        return (
                          <a key={idx} target="_blank" rel="noreferrer" href={el.url} className="cursor-pointer alert-info hoverAlert">
                            {el.key_documento.split("/")[2]}
                          </a>
                        );
                      })}
                    </div>
                  </div>
                </div>
              {/* )} */}

              <div className="d-flex mt-4 aprobacion-modalbtns">
                <div
                  className={`d-flex gap-4 justify-content-${
                    returnAccesos(localStorage.getItem("id_perfil"), obj.id_tipo_solicitud, obj.id_estado_solicitud) || visibleBtns
                      ? "between"
                      : "end"
                  } w-100`}
                >
                  {visibleBotones && (
                    <>
                      {![4].includes(obj.id_estado_solicitud) ? (
                        <div className="d-flex flex-row gap-3">
                          <button
                            className="btn btn-md btn-success d-flex gap-3 align-items-center pe-2"
                            onClick={() => {
                              aceptaSolicitud({ ...obj, aprueba: true });
                            }}
                          >
                            Aprobar <FontAwesomeIcon size="lg" icon={faCheckCircle} />
                          </button>
                          <button
                            className="btn btn-md btn-danger d-flex gap-3 align-items-center pe-2"
                            onClick={() => {
                              cierraModal();
                              rechazaSolicitud({ ...obj, aprueba: false });
                            }}
                          >
                            Rechazar <FontAwesomeIcon size="lg" icon={faXmarkCircle} />
                          </button>
                        </div>
                      ) : (
                        <button
                          className="btn btn-md btn-success d-flex gap-3 align-items-center px-3"
                          onClick={() => {
                            aceptaSolicitud({ ...obj, aprueba: true });
                          }}
                        >
                          Enviar a SAP <FontAwesomeIcon size="lg" icon={faPaperPlane} />
                        </button>
                      )}
                    </>
                  )}
                  <button
                    className={`btn gap-2 d-flex align-items-center py-1 btn-info btn-sm`}
                    data-bs-toggle="tooltip"
                    title="Ver historial"
                    onClick={() => {
                      setIdSolicitud(obj.id);
                      setVisibleHistorial(true);
                    }}
                  >
                    Historial <FontAwesomeIcon icon={faHistory} />
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div>no hay data</div>
          )}
        </>
      )}
    </>
  );
};
